import { DatosActualizarInvestigacion } from "../DatosActualizarInvestigacion";
import { InvestigacionDTO } from "@DTOS";
import { IInvestigacionesState } from "../../investigaciones.state";
import { Nilable } from "@shared/utils";

export abstract class Actualizador<T = InvestigacionDTO> {
    abstract esActualizador(datos: DatosActualizarInvestigacion): boolean;
    abstract actualizar(
        investigacion: InvestigacionDTO, datos: DatosActualizarInvestigacion
    ): Promise<T>;

    public modificarEstado: Nilable<
        (state: IInvestigacionesState, investigacion: InvestigacionDTO, datos: DatosActualizarInvestigacion) => void>;
}
